import { RCS_FALLBACK_REASON_LABELS, RcsFallbackReason } from 'src/app/models/Rcs';

/**
 * Aviso de que a etapa RCS da automação saiu por SMS (decisão do Bruno, 03/11/2026).
 *
 * A regra não muda: sem RCS, o lead recebe o SMS gerado do card pela rota de SMS das automações.
 * Aqui só fica o texto que o CLIENTE lê onde acompanha a automação, sem termo técnico (nada de
 * fallback, cache, consulta, operadora). O detalhe técnico continua em `RCS_FALLBACK_REASON_LABELS`,
 * que só o Admin vê.
 */
export const RCS_FALLBACK_CLIENT_LABELS: Record<RcsFallbackReason, string> = {
  cache_no_rcs: 'este número não tem RCS',
  lookup_no_rcs: 'este número não tem RCS',
  lookup_failed: 'não foi possível confirmar o RCS deste número',
  rcs_refused: 'o RCS foi recusado pelo aparelho',
  invalid_phone: 'o telefone é inválido, então valem as regras do SMS',
  monitored: 'este é um número de monitoramento, que sempre recebe SMS',
  // Decisão do Bruno (03/11/2026): sem rota, sem saldo para o RCS ou erro interno não cancelam mais.
  no_rcs_route: 'o RCS não estava disponível para esta conta',
  rcs_no_funds: 'o RCS não estava disponível para esta conta',
  internal_error: 'o RCS não estava disponível para esta conta',
  rcs_timeout: 'o RCS ficou indisponível por tempo demais',
};

/** Frase inteira do aviso, como o cliente lê: "Enviado por SMS: este número não tem RCS". */
export function rcsFallbackNotice(reason: RcsFallbackReason | string | null | undefined): string {
  if (!reason) {
    return 'Enviado por SMS';
  }
  const why = RCS_FALLBACK_CLIENT_LABELS[reason as RcsFallbackReason];
  return why ? `Enviado por SMS: ${why}` : 'Enviado por SMS';
}

/** Detalhe técnico para o Admin: o rótulo interno e o código gravado em `rcs_messages.fallback_reason`. */
export function rcsFallbackAdminDetail(reason: RcsFallbackReason | string | null | undefined): string | null {
  if (!reason) {
    return null;
  }
  const label = RCS_FALLBACK_REASON_LABELS[reason as RcsFallbackReason];
  return label ? `${label} (${reason})` : reason;
}
